var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#767DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74563 3.65625H10.2544C10.3413 3.65621 10.4267 3.67932 10.5017 3.72322C10.5768 3.76711 10.6387 3.8302 10.6813 3.906L14.5659 10.8354C14.6068 10.9085 14.6283 10.9908 14.6283 11.0745C14.6283 11.1582 14.6068 11.2405 14.5659 11.3136L13.3228 13.5309C13.2804 13.6068 13.2185 13.6699 13.1436 13.7139C13.0686 13.7579 12.9833 13.7811 12.8964 13.7812H5.10356C5.01657 13.7812 4.93116 13.758 4.85612 13.714C4.78108 13.67 4.71912 13.6068 4.67662 13.5309L3.43406 11.3136C3.39317 11.2405 3.3717 11.1582 3.3717 11.0745C3.3717 10.9908 3.39317 10.9085 3.43406 10.8354L7.31869 3.906C7.36125 3.8302 7.42324 3.76711 7.49828 3.72322C7.57332 3.67932 7.65869 3.65621 7.74563 3.65625ZM9 6.41306L6.38269 11.0745H11.6173L9 6.41306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAct);
export default __webpack_public_path__ + "static/media/act.e93d833f0b8cc4136557645812d06354.svg";
export { ForwardRef as ReactComponent };